import { actionTypes } from '../actions/app.action'

const initialState = {
    app: {},
    user: {},
    account: null,
    padrao: {
        color_primary: "#12284C",
        color_secondary: "#ffffff",
        cart_bilhete_bg: "#ffffff",
        cart_bilhete_color: "#000000",
        cart_btn_bg: "#ffc107",
        cart_btn_color: "#000000",
        cart_color: "#ffffff",
        question_bg: "#E2F8FF",
        question_color: "#12284C"
    },
    error: {},
    success: false
}

const appReducer = (state = initialState, { type, payload }) => {
    
    switch (type) {

    case actionTypes.INDEX:
        return { ...state, ...payload }

    case actionTypes.UPDATE:
        return {
            ...state,
            app: {
                ...state.app,
                ...payload
            }
        }

    case actionTypes.CHANGE:
        return {
            ...state,
            app: {
                ...state.app,
                ...payload
            }
        }

    case actionTypes.CHANGE_USER:
        return {
            ...state,
            user: {
                ...state.user,
                ...payload
            }
        }

    case actionTypes.ERROR:
        return {
            ...state,
            error: payload
        }

    case actionTypes.SUCCESS:
        return {
            ...state,
            success: payload
        }

    default:
        return state
    }
}

export default appReducer